import React from 'react';

interface TechBadgeProps {
  label: string;
  size?: 'sm' | 'md';
}

const TechBadge: React.FC<TechBadgeProps> = ({ label, size = 'sm' }) => {
  const sizeClasses = size === 'sm'
    ? 'px-2.5 py-1 text-[11px]'
    : 'px-3 py-1.5 text-xs';

  return (
    <span
      className={`inline-flex items-center rounded-md border border-line bg-canvas-muted/80 text-ink-secondary font-medium ${sizeClasses}`}
    >
      {label}
    </span>
  );
};

export default TechBadge;
